const formatPhoneNumber = (number) => {
  const phoneNumberString = number ? number.toString().replace(/[^\d]/g, '') : null;
  if (phoneNumberString) {
    if (phoneNumberString.length > 6) {
      return (
        '(' +
        phoneNumberString.slice(0, 3) +
        ') ' +
        phoneNumberString.slice(3, 6) +
        '-' +
        phoneNumberString.slice(6, phoneNumberString.length)
      );
    } else if (phoneNumberString.length <= 3) {
      return '(' + phoneNumberString + ')   ' + '-';
      // return "(" + match[1] + ") " + match[2] + "-" + match[3];
    } else if (phoneNumberString.length > 3 && phoneNumberString.length <= 6) {
      return (
        '(' +
        phoneNumberString.slice(0, 3) +
        ') ' +
        phoneNumberString.slice(3, phoneNumberString.length) +
        '-'
      );
    }
  }
  return null;
};

export default formatPhoneNumber;
